module.exports = __webpack_public_path__ + "static/p09_pajaroRvolando-57c65f975a624ddd7b422421a25290aa.png";